<div class="container-workers">
    <div class="container-workers__wrapper">
        <div class="header">
            <h1 class="header__title">
                {{'worker.title'|translate}}
            </h1>

            <p-tabMenu
                [model]="tabMenu"
                [activeItem]="activeTabOption"
                class="header__tab-menu"
            ></p-tabMenu>
        </div>

        <div class="content">
            <div class="content__filters">
                <div class="left">
                    <div class="content__filters__search-box">
                        <i class="pi pi-search icon"></i>
                        <input
                            [(ngModel)]="searchWorkersValue"
                            (ngModelChange)="searchWorkersValue$.next($event)"
                            type="text"
                            pInputText
                            [placeholder]="'labels.search'|translate"
                        >
                    </div>
                    <app-filter-control
                      *ngIf="isActiveDriverLicenseColumn && filtersDriverLicenseStatusConfig"
                      [selectedControlValue]="filterDriverLicenseStatusCurrentValue"
                      (onSubmitFilters$)="onSubmitFilters($event, filtersDriverLicenseStatusConfig)"
                      [data]="filtersDriverLicenseStatusConfig"
                      [optionsSelectedCount]="filterDriverLicenseStatusCurrentValue ? $any(filterDriverLicenseStatusCurrentValue.selectedControlValue?.length) : 0"
                    ></app-filter-control>
                    <button (click)="openWorkerForm()" pButton type="button" [label]="'worker.add'|translate" class="content__filters__submit"></button>
                </div>
                <div class="right">
                    <button (click)="exportFiles()" class="export-btn">
                        <span>{{'labels.export'|translate}}:</span>
                        <div class="export-btn__icon">
                            <i class="pi pi-file-export"></i>
                        </div>
                    </button>
                </div>
            </div>

            <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: currentListPageData }"></ng-container>

            <div class="content__footer">
                <div class="left">
                    <ng-container *ngIf="countCheckedRow()">
                        <span class="count-checked-row">{{ countCheckedRow() }} {{'labels.selected'|translate}}</span>
                        <button (click)="activeView === VIEW.Active ? onWorkersArchived() : onWorkersRestore()" class="button-submit-checked-row">
                            <span>
                                {{ activeView === VIEW.Active ? ('labels.archive' | translate) : ('labels.restore' | translate) }}
                            </span>
                        </button>
                    </ng-container>
                </div>
                <div class="right">
                    <p-paginator
                        #paginator
                        [rows]="rowsPerPage"
                        [totalRecords]="totalRecordsDisplayedList"
                        [rowsPerPageOptions]="[10, 20, 30]"
                        (onPageChange)="onChangePaginate($event)"
                    ></p-paginator>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #tableTemplate let-data>
    <div #containerList class="content__list">
        <p-table
            [value]="data"
            [scrollable]="true"
            [scrollHeight]="listHeight"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th class="name-column">
                        <p-checkbox
                            (ngModelChange)="onChangeValueCheckedAll($event)"
                            [(ngModel)]="isCheckedAll"
                            [binary]="true"
                        ></p-checkbox>
                        <span>{{'labels.first-name-and-last-name'|translate}}</span>
                    </th>
                    <th>{{'labels.email'|translate}}</th>
                    <th>{{'labels.phone-number'|translate}}</th>
                    <th *ngIf="activeView === VIEW.Active" style="min-width: 250px; width: 250px; position: relative;">
                        {{'driverLicense'|translate}}
                        <ng-container *ngIf="!isActiveDriverLicenseColumn">
                            <ng-container *ngTemplateOutlet="driverLicenseInfoDisabled"></ng-container>
                        </ng-container>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr
                    (click)="activeView === VIEW.Active && openWorkerForm(item)"
                    [ngClass]="{'active-view': activeView === VIEW.Active}"
                    class="content__list__item"
                >
                    <td class="name-column">
                        <p-checkbox
                            (click)="$event.stopPropagation()"
                            [(ngModel)]="item.isChecked"
                            [binary]="true"
                            [disabled]="activeView === VIEW.Active && item.data.U"
                        ></p-checkbox>
                        <span>{{item.data.FN}} {{item.data.LN}}</span>
                    </td>
                    <td>{{item.data.Em || '-'}}</td>
                    <td>{{item.data.CN || '-'}}</td>
                    <ng-container *ngIf="activeView === VIEW.Active">
                      <ng-container *ngTemplateOutlet="driverLicenseStatus; context: { workerData: item }"></ng-container>
                    </ng-container>
                </tr>
            </ng-template>
        </p-table>
    </div>
</ng-template>

<ng-template #driverLicenseStatus let-workerData="workerData">
    <td
      [ngClass]="{
        'not-checked-yet': workerData.data.LS === DRIVER_LICENSE_STATUS.NotCheckedYet,
        'active': workerData.data.LS === DRIVER_LICENSE_STATUS.Valid,
        'invalid': workerData.data.LS === DRIVER_LICENSE_STATUS.Invalid,
        'no-data': workerData.data.LS === DRIVER_LICENSE_STATUS.InsufficientData,
        'document-not-found': workerData.data.LS === DRIVER_LICENSE_STATUS.DocumentNotFound
      }"
      class="driver-license-column active"
    >
        <ng-container *ngIf="isActiveDriverLicenseColumn">
            <div [hidden]="workerData.data.L === null" class="driver-license-column__dot"></div>
            <span
              [ngClass]="{ 'no-license-data': workerData.data.L === null }"
              [pTooltip]="driverLicenseNumberTooltip"
              tooltipPosition="top"
              tooltipStyleClass="tooltip-driver-licesnse-number"
              class="driver-license-column__status"
            >
              <span>{{ workerData.data | driverStatusToText : translateService }}</span>
            </span>
        </ng-container>
    </td>

    <ng-template #driverLicenseNumberTooltip>
        <div class="driver-license-tooltip-text">
            <span>{{'driverLicenseNumber'|translate}}: <b> {{ workerData.data?.L || ('labels.no-data' | translate) }}</b></span>
        </div>
    </ng-template>
</ng-template>

<ng-template #driverLicenseInfoDisabled>
    <div
        [ngStyle]="{ 'height': 'calc(' + listHeight + ' - 55px)' }"
        class="driver-license-info-disabled"
    >
        <div class="driver-license-info-disabled__icon">
            <i class="pi pi-lock"></i>
        </div>
        <span class="driver-license-info-disabled__title">
            {{ 'functionInActive' | translate }}
        </span>
        <span class="driver-license-info-disabled__description">
            {{ 'driverLicenseCheckStatusInfo' | translate }}
        </span>

        <span class="driver-license-info-disabled__contact">
          {{ 'driverLicenseDoYouNeedText' | translate }}
        </span>

        <span class="driver-license-info-disabled__contact">
          +48 609 111 114 <br> <a href="mailto:serwis@tekom.pl">serwis&#64;tekom.pl</a>
        </span>

        <!-- <button class="driver-license-info-disabled__active-btn" pButton type="button" [label]="'activate'|translate"></button>
        <span
          [innerHTML]="'priceForDriverLicenseStatusFunction' | translate : {value: '3.99'}"
          class="driver-license-info-disabled__price"
        ></span> -->
    </div>
</ng-template>
